import React, { Component } from "react";
import ICatalog_Item from "../../../models/ICatalog_Item";
import "./ItemInventoryByWarehouseModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { QtyOnHandValue } from "../../shared/QtyOnHandValue/QtyOnHandValue";

type Props = {
    closeModalFn: () => void;
    catalogItem: ICatalog_Item;
};

export const ItemInventoryByWarehouseModal: React.FC<Props> = (props) => {
    const closeModal = () => {
        props.closeModalFn();
    };

    return (
        <div className={"ItemInventoryByWarehouseModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-warehouse"} title={"inventory_by_warehouse"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-4"}>
                <h5>{props.catalogItem.sku}</h5>
                <div className={"inventory-rows"}>
                    {props.catalogItem.Warehouse_Catalog_Items_Maps?.filter((mapDetail) => !mapDetail.Warehouse?.is_hidden).map(
                        (mapDetail) => {
                            return (
                                <div key={mapDetail.guid} className={"d-flex"}>
                                    <div className={"w-50 text-bold"}>{mapDetail.Warehouse?.name}</div>
                                    <div className={"w-50"}>
                                        <QtyOnHandValue catalogItem={props.catalogItem} mapItem={mapDetail} />
                                    </div>
                                </div>
                            );
                        }
                    )}
                </div>
            </div>
        </div>
    );
};
